import { Division, State } from '@tripointe/tripointe-cms/data-access';
import { DropdownItem } from '@tripointe/tripointe-cms/types';
import { stateToOption } from './dropdown.utils';

const stateMatchCountry = (countryId: number) => (state: State) => state?.country?.id === countryId;

export const getFilteredStatesOptions = ([states, countryId]: [
  Partial<State>[],
  number
]): DropdownItem[] => {
  return countryId
    ? states.filter(stateMatchCountry(countryId)).map(stateToOption)
    : states.map(stateToOption);
};

export const checkDivisionCountryId = (state: Partial<State>) => (
  division: Partial<Division>
): boolean => {
  return state?.country.id === division?.country.id;
};

export const sortStatesInDropdown = (a: DropdownItem, b: DropdownItem): number => {
  return a.text.localeCompare(b?.text);
};
